export const SET_PAGE = 'SET_PAGE';
export const PREVIOUS_PAGE = 'PREVIOUS_PAGE';
export const MOVE_TO_PAGE = 'MOVE_TO_PAGE';
export const SET_RESET_PASSWORD_STEP = 'SET_RESET_PASSWORD_STEP';

export const setPage = page => ({
    type: SET_PAGE,
    payload: page,
})

export const previousPage = () => ({
    type: PREVIOUS_PAGE,
})

export const moveToPage = page => ({
    type: MOVE_TO_PAGE,
    payload: page,
})

export const setResetPasswordStep = (step) => ({
    type: SET_RESET_PASSWORD_STEP,
    payload: step,
})

export const RESET_PASSWORD_LABELS = {
    email: 'Send Request',
    code: 'Verify Code',
    newPassword: 'Set New Password',
    success: 'Sign In',
};
